<a
class="btn btn-primary btn-stretch"
  href="{{ component.data.src }}"
  target="_blank"
  (click)="onDownloadPressed()"
  ><i class="bx bx-download" *ngIf="component.data.showIcon"></i>
  {{ component.data.text }}</a
>